import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, type Tag } from "@/lib/api";

export function useTags() {
  return useQuery({ queryKey: ["tags"], queryFn: () => api<{ tags: Tag[] }>("/api/tags").then((r) => r.tags), staleTime: 60_000 });
}

export function useCreateTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => api<{ tag: Tag }>("/api/tags", { json: { name } }).then((r) => r.tag),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["tags"] }),
    onError: (e) => toast.error(e.message),
  });
}
